<div
  #container
  class="card_wrapper"
  cdkDrag
  cdkDragBoundary="wrapper"
  [appClickRestrict]="progress"
>
  <div class="card" id="widget-card">
    <header class="header" cdkDragHandle>
      <p>{{ widgetInfo.title }}</p>
      <img
        *ngIf="widgetInfo?.widgetName !== 'SOS_SIGN'"
        src="/assets/icons/reservation_summary/edit_icon_gold.svg"
        alt="Edit Icon"
        class="edit_icon"
      />
    </header>
    <div
      class="body"
      [hidden]="
        !(
          (widgetInfo?.widgetName != 'SIDEKICK_SETUP' &&
            widgetInfo?.widgetName != 'SOS_SIGN') ||
          (widgetInfo?.widgetName == 'SIDEKICK_SETUP' &&
            !(showFailure || showSuccess || showDisconnect))
        )
      "
    >
      <p class="desc">{{ widgetInfo.description }}</p>
      <app-dynamic-form-landing
        [formSections]="widgetInfo.form"
        [showButtons]="false"
        [valuesToPatch]="widgetInfo.formValues"
        (closeCalenderEvent)="isClose($event)"
      ></app-dynamic-form-landing>
      <div class="btn_container">
        <button class="btn btn-danger-outline btn-lg" (click)="cancel($event)">
          Cancel
        </button>
        <button
          class="btn btn-primary btn-lg"
          (click)="submitConfirm()"
          [appProgressButton]="progress"
          [buttonText]="'Save'"
          [disabled]="!enableButton"
        >
          Save
        </button>
      </div>
    </div>
    <ng-container *ngIf="widgetInfo?.widgetName == 'SIDEKICK_SETUP'">
      <div class="card__loader" *ngIf="showProgress">
        <img src="/assets/loaders/bloom_spinner.gif" alt="loader" />
        <p class="card__loader__text">
          {{ isLoggedIn ? "Connecting" : "Logging In" }}
        </p>
      </div>
      <div class="card__failure" *ngIf="showFailure">
        <p class="card__failure__text">
          {{ testErrorMessage }}
        </p>
        <object
          class="card__failure__cross"
          type="image/svg+xml"
          data="/assets/icons/animated/cancelled.svg"
        ></object>
        <div class="card__failure__buttons">
          <button
            class="btn btn-danger-outline btn-lg"
            (click)="cancel($event)"
          >
            Close
          </button>
          <button
            *ngIf="!testConnection"
            class="btn btn-primary btn-lg"
            (click)="
              testConnection ? pushSidekickScreen() : retrySidekickConnect()
            "
          >
            Retry
          </button>
          <button
            *ngIf="testConnection"
            class="card__success__text__send"
            (click)="pushSidekickScreen()"
            [class.processing]="!buttonEnabled"
            [ngStyle]="{ 'margin-left': '16px' }"
          >
            <img
              class="card__success__text__send__image"
              [src]="
                !buttonEnabled
                  ? '/assets/icons/action-dialog/iconDisabled.svg'
                  : '/assets/icons/action-dialog/sidekickBtn.svg'
              "
              alt=""
            />
            <span>Retry</span>
          </button>
        </div>
      </div>
      <div class="card__success" *ngIf="showSuccess && !showDisconnect">
        <p class="card__success__text">
          SideKick Device has been connected successfully!
        </p>
        <object
          class="card__success__tick"
          type="image/svg+xml"
          data="/assets/icons/animated/check_mark.svg"
        ></object>
      </div>
      <div
        class="card__success connectedToPms"
        *ngIf="showDisconnect && !showFeedback"
      >
        <p class="card__success__text">
          Connect to a different SideKick Device?
        </p>
        <div class="card__success__buttons disconnect">
          <button
            class="btn btn-danger-outline btn-lg"
            (click)="disconnectDevice()"
          >
            Disconnect
          </button>
          <button
            class="card__success__text__send"
            (click)="
              pushSidekickScreen(
                SideKickInterfaceTypeUiEnum.SIDEKICK_SCREEN_TEST
              )
            "
            [class.processing]="!buttonEnabled"
          >
            <img
              class="card__success__text__send__image"
              [src]="
                !buttonEnabled
                  ? '/assets/icons/action-dialog/iconDisabled.svg'
                  : '/assets/icons/action-dialog/sidekickBtn.svg'
              "
              alt=""
            />
            <span>Test</span>
          </button>
        </div>
        <div class="seperator__condition">
          <div class="seperator__dashedTop"></div>
          <div>OR</div>
          <div class="seperator__dashedTop"></div>
        </div>
        <button
          class="card__success__text__send"
          (click)="
            pushSidekickScreen(
              SideKickInterfaceTypeUiEnum.SELF_CHECK_IN_DEFAULT
            )
          "
          [class.processing]="!buttonEnabled"
        >
          <img
            class="card__success__text__send__image"
            [src]="
              !buttonEnabled
                ? '/assets/icons/action-dialog/iconDisabled.svg'
                : '/assets/icons/action-dialog/sidekickBtn.svg'
            "
            alt=""
          />
          <span>Push Self Check-In</span>
        </button>
        <button
          class="card__success__text__send"
          (click)="
            pushSidekickScreen(SideKickInterfaceTypeUiEnum.BOOKING_DEFAULT)
          "
          [class.processing]="!buttonEnabled"
        >
          <img
            class="card__success__text__send__image"
            [src]="
              !buttonEnabled
                ? '/assets/icons/action-dialog/iconDisabled.svg'
                : '/assets/icons/action-dialog/sidekickBtn.svg'
            "
            alt=""
          />
          <span>Push Pay At Hotel</span>
        </button>
        <div
          class="seperator__condition"
          *ngIf="
            (propertyData?.feedbackUrl && propertyData?.feedbackUrl !== '') ||
            (propertyData?.feedbackUrl2 && propertyData?.feedbackUrl2 !== '')
          "
        >
          <div class="seperator__dashedTop"></div>
          <div>OR</div>
          <div class="seperator__dashedTop"></div>
        </div>
        <button
          *ngIf="
            (propertyData?.feedbackUrl && propertyData?.feedbackUrl !== '') ||
            (propertyData?.feedbackUrl2 && propertyData?.feedbackUrl2 !== '')
          "
          class="btn btn-secondary-outline btn-lg"
          (click)="showFeedbackData()"
        >
          Feedback Options
        </button>
      </div>
      <div class="card__failure" *ngIf="showFeedback && !showFailure">
        <p class="card__failure__text">
          Push hotel review screen on the SideKick Device.
        </p>
        <br />
        <div class="feedback">
          <button
            *ngIf="
              propertyData?.feedbackUrl && propertyData?.feedbackUrl !== ''
            "
            class="card__success__text__send"
            (click)="
              pushSidekickScreen(
                SideKickInterfaceTypeUiEnum.FRONT_DESK_ASSISTANT_FEEDBACK_EXTERNAL,
                'Google'
              )
            "
            [class.processing]="!buttonEnabled"
          >
            <img
              class="card__success__text__send__image"
              [src]="
                !buttonEnabled
                  ? '/assets/icons/action-dialog/iconDisabled.svg'
                  : '/assets/icons/action-dialog/sidekickBtn.svg'
              "
              alt=""
            />
            <span>Push Google review</span>
          </button>
          <button
            *ngIf="
              propertyData?.feedbackUrl2 && propertyData?.feedbackUrl2 !== ''
            "
            class="card__success__text__send feedback__tripadvisor"
            (click)="
              pushSidekickScreen(
                SideKickInterfaceTypeUiEnum.FRONT_DESK_ASSISTANT_FEEDBACK_EXTERNAL,
                'Tripadvisor'
              )
            "
            [class.processing]="!buttonEnabled"
          >
            <img
              class="card__success__text__send__image"
              [src]="
                !buttonEnabled
                  ? '/assets/icons/action-dialog/iconDisabled.svg'
                  : '/assets/icons/action-dialog/sidekickBtn.svg'
              "
              alt=""
            />
            <span>Push TripAdvisor review</span>
          </button>
        </div>
        <br />
        <button
          class="btn btn-danger-outline btn-lg"
          (click)="showFeedbackData()"
        >
          Go Back
        </button>
      </div>
    </ng-container>

    <div
      *ngIf="widgetInfo?.widgetName == 'SOS_SIGN'"
      [ngClass]="{ dimmed: showProgress }"
    >
      <div class="card__loader" *ngIf="showProgress">
        <img src="/assets/loaders/bloom_spinner.gif" alt="loader" />
        <p class="card__loader__text">Processing</p>
      </div>
      <div class="emergency-evac" *ngIf="!isEvacMessageSent">
        <div class="emergency-evac__head">EMERGENCY EVACUATION</div>
        <div class="emergency-evac__desc">
          Automated messages and calls will be sent to
          <span class="emergency-evac__message">In-house</span> guests to
          immediately evacuate and to
          <span class="emergency-evac__message">Staff</span> to report to
          assigned areas.
        </div>
        <app-dynamic-form-landing
          #evacForm
          class="evac-reason"
          [formSections]="widgetInfo.form"
          [showButtons]="false"
          (fieldValueChanged)="fieldValueChanged($event, 'evacuation')"
        ></app-dynamic-form-landing>
        <div *ngIf="showErrorText" class="error-message">
          *Minimum 4 characters are required.
        </div>
        <button
          [disabled]="!enableEvacButton"
          class="card__success__text__send emergency-evac__btn"
          (click)="emergencyEvacNotification('evacuation')"
        >
          <img
            class="card__success__text__send__image"
            [src]="
              !enableEvacButton
                ? '/assets/icons/action-dialog/iconDisabled.svg'
                : '/assets/icons/action-dialog/sidekickBtn.svg'
            "
            alt=""
          />
          <span>Emergency Evacuation</span>
        </button>
        <div class="seperator__condition">
          <div class="seperator__dashedTop"></div>
          <div>OR</div>
          <div class="seperator__dashedTop"></div>
        </div>
        <div class="emergency-evac__drill">EVACUATION DRILL</div>
        <div class="emergency-evac__desc">
          Guests and staff will be notified about the mock drill via messages
          and calls.
        </div>
        <app-dynamic-form-landing
          #drillForm
          class="drill-reason"
          [formSections]="widgetInfo.form1"
          [showButtons]="false"
          (fieldValueChanged)="fieldValueChanged($event, 'drill')"
        ></app-dynamic-form-landing>
        <div *ngIf="showDRillErrorText" class="error-message">
          *Minimum 4 characters are required.
        </div>
        <button
          [disabled]="!enableButton"
          class="card__success__text__send emergency-evac__drillBtn"
          (click)="emergencyEvacNotification('drill')"
        >
          <img
            class="card__success__text__send__image"
            [src]="
              !enableButton
                ? '/assets/icons/action-dialog/iconDisabled.svg'
                : '/assets/icons/action-dialog/sidekickBtn.svg'
            "
            alt=""
          />
          <span>Evacuation Drill</span>
        </button>
      </div>
      <div
        class="emergency-evac emergency-evac__successText"
        *ngIf="isEvacMessageSent"
      >
        <div
          class="emergency-evac__head"
          [ngClass]="isDrillEvac ? 'emergency-evac__drillEvac' : ''"
        >
          {{ isDrillEvac ? "EVACUATION DRILL" : "EMERGENCY EVACUATION" }} HAS
          BEEN SUCCESSFULLY TRIGGERED.
        </div>
        <div
          class="emergency-evac__head emergency-evac__messageArea"
          [ngClass]="isDrillEvac ? 'emergency-evac__drillEvac' : ''"
        >
          PLEASE REPORT TO THE ASSIGNED AREAS.
        </div>
      </div>
    </div>
  </div>
</div>
